import React, { useRef, useEffect } from 'react';
import Icon from 'icon';
import { Link } from 'gatsby';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Accordeon from './accordeon';
import s from './nav.module.scss';

export default function Nav({ active, handleNav, inView, pages, categories, hoverOut }) {
  const nav = useRef({});
  useEffect(() => {
    if (active) {
      disableBodyScroll(nav.current);
    } else {
      clearAllBodyScrollLocks();
    }
  }, [active]);
  return (
    <nav ref={nav} className={`${s.nav} ${active ? s.active : ''}`}>
      <div className={s.closeWrapper} onClick={() => handleNav()}>
        <Icon icon="times" className={s.close} />
      </div>
      <ul className={s.list}>
        {pages.map(({ text, href, type, hoverHandler }) => {
          return (
            <li
              className={s.listItem}
              key={`${text}--nav`}
              onMouseEnter={hoverHandler}
            >
              {/* Navbar Link, it can be internal or optionally extenal */}
              {
                type !== 'external'
                  ?
                  (
                    <Link
                      className={`${s.link} ${s[text.toLowerCase()]}`}
                      to={`${href}`}
                      onClick={() => {
                        hoverOut();
                        if (window.innerWidth <= 1229) {
                          handleNav();
                        }
                      }}
                    >
                      {text}
                    </Link>
                  )
                  :
                  (
                    <a
                      className={`${s.link} ${s[text.toLowerCase()]}`}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {text}
                    </a>
                  )
              }
              {categories[text.toLowerCase()] &&
                categories[text.toLowerCase()].subcategories.length > 0 ? (
                  <Accordeon
                    handleNav={handleNav}
                    items={categories[text.toLowerCase()].subcategories}
                  />
                ) : null}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
